module.exports = __webpack_public_path__ + "static/media/recruitment-2.1f1d52f6.png";